import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import '@mux/mux-player';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HeaderInterceptorService } from './app/utilities/services/Interceptors/header-interceptor.service';

// ✅ Set default theme before app bootstraps
const storedTheme = localStorage.getItem('theme');
if (!storedTheme || storedTheme === 'light') {
  localStorage.setItem('theme', 'light'); // Optional: persist
}
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptorService,
      multi: true,
    }
  ]
}).catch((err) => console.error(err));